export const Title = ({ title }: { title?: string }) => {
  if (!title) return (
    <title>
      IckleSquishyBot
    </title>
  );
  
  return (
    <title>
      IckleSquishyBot | { title }
    </title>
  );
};